module.exports = __webpack_public_path__ + "static/img/customize-bg.4649dc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/customize-bg.png
// module id = YIB/
// module chunks = 0